export enum Step {
    checked = 'CHECKED',
    unchecked = 'UNCHECKED',
    null = 'NULL'
}
